/**
 * Whether crash reports actually reach Sentry in this environment.
 *
 * Kept separate from `initSentry` so the error screen can read it without pulling the Sentry
 * SDK into modules (and tests) that have no business initialising it.
 */
let sentryReportingEnabled = false;

export function setSentryReportingEnabled(enabled: boolean): void {
  sentryReportingEnabled = enabled;
}

export function isSentryReportingEnabled(): boolean {
  return sentryReportingEnabled;
}

/**
 * Decide whether the "Reference" on the error screen is worth showing.
 *
 * Sentry's ErrorBoundary hands the fallback a locally generated event id even when
 * `Sentry.init` never ran (it is disabled outside staging/production), so the id can look
 * perfectly legitimate while existing nowhere. Quoting one of those to support is a dead end,
 * so we only show a reference we know was actually reported.
 */
export function resolveSupportReference(eventId: string | undefined): string | undefined {
  return isSentryReportingEnabled() ? eventId : undefined;
}
